import { render } from "./Video.vue?vue&type=template&id=2fde1481&scoped=true&ts=true&lang=pug"
import script from "./Video.vue?vue&type=script&lang=ts"
export * from "./Video.vue?vue&type=script&lang=ts"

import "./Video.vue?vue&type=style&index=0&id=2fde1481&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fde1481"]])

export default __exports__